import React from 'react';

import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './saga/sagas.js';
import logger from 'redux-logger';
import { rootReducer } from './reducer/combineReducer';
import {MuiThemeProvider} from '@material-ui/core/styles';
import {theme} from './theme';
import { Provider as AlertProvider } from "react-alert";
import AlertMUITemplate from "react-alert-template-mui";

import './css/main.css';
import './css/menu.css';
import './css/user.css';
import './css/column.css';
import './css/button.css';
import './css/paging.css';
import './css/modal.css';
import './css/profile.css';
import './css/talk.css';
import './css/balloon.css';
import './css/icon.css';
import './css/home.css';
import './css/timeline.css';
import './css/setting.css';
import './css/table.css';
import './css/animation.css';

import Router from "./Router";
let middlewares = [];
const sagaMiddleware = createSagaMiddleware();
middlewares.push(sagaMiddleware);
if(process.env.NODE_ENV !== 'production') {
  middlewares.push(logger)
}

const store = createStore(
	rootReducer,
	applyMiddleware(...middlewares),
);
sagaMiddleware.run(rootSaga);

function App() {
  return (
    <Provider store={ store }  >
      <AlertProvider template={AlertMUITemplate} >
  			<MuiThemeProvider theme={theme}>
        	<Router />
  				<div id='muiConfirm' />
  			</MuiThemeProvider>
      </AlertProvider>
    </Provider>

  );
}

export default App;
